var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Authenticator } from '../authentication/services/Authenticator';
import { LanguageService } from './../../common/services/LanguageService';
import ENV from 'config/env';
import { injectable } from 'tsyringe';
var qs = require('qs');
var AppLinkHelper = /** @class */ (function () {
    function AppLinkHelper(authenticator, languageService) {
        this.authenticator = authenticator;
        this.languageService = languageService;
        this.apps = ENV.APPS;
    }
    Object.defineProperty(AppLinkHelper.prototype, "crossSiteQueryParams", {
        get: function () {
            return {
                lang: this.languageService.currentLanguage,
                company_id: "" + this.authenticator.getSelectedCompany(),
                token: this.authenticator.getToken(),
            };
        },
        enumerable: false,
        configurable: true
    });
    AppLinkHelper.prototype.getAppLink = function (app, path, queryObject) {
        if (path === void 0) { path = ''; }
        if (queryObject === void 0) { queryObject = {}; }
        if (this.apps[app]) {
            return "" + this.apps[app].URL + path + "?" + this.convertQueryParameters(queryObject);
        }
        return null;
    };
    AppLinkHelper.prototype.convertQueryParameters = function (queryObject) {
        if (queryObject === void 0) { queryObject = {}; }
        queryObject = __assign(__assign({}, this.crossSiteQueryParams), queryObject);
        return qs.stringify(queryObject, { arrayFormat: 'indices', encode: false });
    };
    var _a, _b;
    AppLinkHelper = __decorate([
        injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof Authenticator !== "undefined" && Authenticator) === "function" ? _a : Object, typeof (_b = typeof LanguageService !== "undefined" && LanguageService) === "function" ? _b : Object])
    ], AppLinkHelper);
    return AppLinkHelper;
}());
export { AppLinkHelper };
